import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=0e499382&scoped=true&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"
import style0 from "./Demand.vue?vue&type=style&index=0&id=0e499382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e499382",
  null
  
)

export default component.exports